<template>
  <div>
    <!-- <nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active" aria-current="page">Home</li>
  </ol>
</nav>

<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a href="#">CoreUI</a></li>
    <li class="breadcrumb-item active" aria-current="page">Library</li>
  </ol>
</nav> -->
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <strong>Stream</strong>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol md="8">
                <CForm>
                  <CInput
                    label="Stream Name *"
                    v-model="stream.name"
                    placeholder="Stream Name..."
                    horizontal
                    autocomplete="name"
                    :disabled="mode.viewMode"
                    :invalid-feedback="'Please Enter the Stream Name'"
                    :is-valid="
                      $v.stream.name.$dirty ? !$v.stream.name.$error : null
                    "
                    @blur="$v.stream.name.$touch()"
                  />
              <CInput
                    label="Stream Order *"
                    v-model="stream.orderCode"
                    placeholder="Stream Order..."
                    horizontal
                    type="number"
                    :disabled="mode.viewMode"
                    :invalid-feedback="'Please Enter the Stream Order'"
                    :is-valid="
                      $v.stream.orderCode.$dirty ? !$v.stream.orderCode.$error : null
                    "
                    @blur="$v.stream.orderCode.$touch()"
                  />
                  <CTextarea
                    label="Stream Description"
                    v-model="stream.description"
                    placeholder="Stream Description..."
                    horizontal
                    rows="6"
                    autocomplete="name"
                    :disabled="mode.viewMode"
                    :invalid-feedback="'Please Enter the Stream Description'"
                   
                  />

                  <MultiSelect
                    label="Categories "
                    :options="allCategories"
                    :hide-selected="false"
                    :searchable="true"
                    optionLabel="name"
                    :disabled="mode.viewMode"
                    track-by="id"
                    :track-ids.sync="stream.categoryId"
                    idParamName="id"
                    :itemTypeisString="false"
                   invalidFeedback="Select One Categories"
                  ></MultiSelect>
                    <!-- :invalid-feedback="'Please Enter the Stream Description'"
                    :is-valid="
                      $v.stream.categoryId.$dirty ? !$v.stream.categoryId.$error : null
                    "
                    @blur="$v.stream.categoryId.$touch()" -->
                </CForm>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter align="right">
            <CButton
              class="mr-2"
              v-if="mode.viewMode"
              type="submit"
              color="secondary"
              @click="editMode()"
              >Edit</CButton
            >
            <CButton
              class="mr-2"
              v-if="!mode.viewMode"
              type="submit"
              color="success"
              @click="saveStream()"
              >Save</CButton
            >
            <CButton class="mr-2" type="Cancel" color="danger" @click="cancel()"
              >Cancel</CButton
            >
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import Vue from "vue";
import MultiSelect from "../../containers/MultiSelect";
import { required } from "vuelidate/lib/validators";
export default {
  name: "Stream",
  components: {
    MultiSelect,
  },
  data() {
    return {
      mode: {
        newMode: false,
        editMode: false,
        viewMode: false,
      },
      streamId: "",
      allCategories: [],
      stream: {
        streamId: "",
        categoryId: "",
        description: "",
        orderCode:"",
        name: "",
      },
    };
  },
  validations: {
    stream: {
      name: {
        required,
      },
     orderCode:{
       required,
     },
     categoryId:{
       //required,
     }
    },
  },
  created() {
    if (this.$route.params.mode == "new") {
      this.mode.newMode = true;
      this.mode.viewMode = false;
      this.mode.editMode = false;
    }
    if (this.$route.params.mode == "view") {
      this.mode.viewMode = true;
      this.streamId = this.$route.params.streamId;
      this.getStream();
    } else if (this.$route.params.mode == "edit") {
      this.mode.editMode = true;
      this.streamId = this.$route.params.streamId;
      this.getStream();
    }
  },
  methods: {
    editMode() {
      this.mode.editMode = true;
      this.mode.viewMode = false;
    },
    cancel() {
      this.$router.push({ name: "Streams" });
    },

    getStream() {
      this.apiGetSecure(
        process.env.VUE_APP_API_HOST +
          "/web/secure/course_stream/" +
          this.streamId
      )
        .then((response) => response.json())
        .then((data) => (this.stream = data));
    },
    validator(val) {
      return val ? val.length >= 4 : false;
    },
    getCategories() {
      this.apiGetSecure(process.env.VUE_APP_API_HOST + "/web/secure/courses")
        .then((response) => response.json())
        .then((data) => (this.allCategories = data));
      console.log(this.allCategories);
    },
    saveStream() {
      this.$v.stream.$touch();
      if (this.$v.stream.$invalid) {
        console.log("form is invalid", JSON.stringify(this.$v.stream));
      } else {
        this.apiPostSecure(
          process.env.VUE_APP_API_HOST + "/web/secure/save/course/stream",
          this.stream
        ).then((post) => {
          this.$router.push({ name: "Streams" });
        });
      }
    },
  },
  mounted() {
    this.getCategories();
  },
};
</script>
